import AuthScreen from "./AuthScreen";

/**
 * Login — `/` route. Split-screen auth, Sign in tab active.
 */
function Login() {
    return <AuthScreen defaultTab="login" />;
}

export default Login;
